import { render, staticRenderFns } from "./SmallCard.vue?vue&type=template&id=6b0b0272&"
import script from "./SmallCard.vue?vue&type=script&lang=js&"
export * from "./SmallCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0b0272')) {
      api.createRecord('6b0b0272', component.options)
    } else {
      api.reload('6b0b0272', component.options)
    }
    module.hot.accept("./SmallCard.vue?vue&type=template&id=6b0b0272&", function () {
      api.rerender('6b0b0272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/gobierto_dashboards/webapp/components/SmallCard.vue"
export default component.exports